const trimText = (text) => {
  // Trim all whitespaces in front and end of the text, but not in between words
  return text
    ?.trim()
    ?.split(/[\s\t\n]+/)
    ?.join(' ');
};

export default trimText;
